
import EazyHeading from '@/components/EazyHeading.vue';
import requestAPI from '@/logic/requestBeApi';
import router from '@/router/index';
import store from '@/store/index';
import AvatarProgressCircle from '@/components/AvatarProgressCircle.vue';
import getMeetingDateAndTime from '@/logic/helpers/dates/getMeetingDateAndTime';
import hoursOfAssessment from '@/logic/helpers/dates/hoursOfAssessment';

export default {
  components: {
    EazyHeading,
    AvatarProgressCircle,
  },

  data(): Record<string, unknown> {
    return {
      router,
      userRole: store.state.userRole,
      somethingBooked: false,
      deadlinesThisDay: false,
      fetchingAssessments: false,
      fetchingDeadlines: false,
      assessments: [],
      assessmentRequests: [],
      date: this.$route.query.date,
      fetchDeadlines: this.$route.query.fetchDeadlines,
      getMeetingDateAndTime,
      hoursOfAssessment,
    };
  },

  created(): void {
    if (this.userRole === 'assessor') this.getAssessments();
    if (this.fetchDeadlines === 'true') this.getDeadlines();
  },

  methods: {
    async getAssessments(): Promise<void> {
      this.fetchingAssessments = true;

      const resp = await requestAPI({
        url: `/api/v1/assessors/me/assessment-dates?assessment_date[from]=${this.date}&assessment_date[to]=${this.date}`,
        method: 'GET',
      });

      if (resp.ok) {
        const data = await resp.json();

        this.assessments = data.sort(
          (
            assessment: { assessment_dates: { date_start: string | number | Date }[] },
            nextAssessment: { assessment_dates: { date_start: string | number | Date }[] },
          ) => {
            return (
              new Date(assessment.assessment_dates[0].date_start).getTime() -
              new Date(nextAssessment.assessment_dates[0].date_start).getTime()
            );
          },
        );

        this.somethingBooked = this.assessments.length;
      } else if (resp.status !== 401) this.$message.error(this.$t('someErrorOccurred'));

      this.fetchingAssessments = false;
    },

    async getDeadlines(): Promise<void> {
      this.fetchingDeadlines = true;

      const query =
        this.userRole === 'assessor'
          ? 'assessment_request_assessors.status[]=confirmed&assessment_request_assessors.status[]=co_assessor_accepted'
          : 'status=confirmed';
      const resp = await requestAPI({
        url: `/api/v1/${this.userRole}s/me/assessment-requests?${query}`,
        method: 'GET',
      });

      if (resp.ok) {
        const data = await resp.json();
        this.assessmentRequests = data.filter(
          (assessmentReq: { deadline: string | number | Date }) => {
            const deadlineDate = new Date(assessmentReq.deadline);
            const pickedDate = new Date(this.date);
            const deadlineIsToday =
              `${deadlineDate.getFullYear()}-${deadlineDate.getMonth() +
                1}-${deadlineDate.getDate()}` ===
              `${pickedDate.getFullYear()}-${pickedDate.getMonth() + 1}-${pickedDate.getDate()}`;

            if (deadlineIsToday) return assessmentReq;
          },
        );
        this.deadlinesThisDay = this.assessmentRequests.length;
      } else if (resp.status !== 401) this.$message.error(this.$t('someErrorOccurred'));

      this.fetchingDeadlines = false;
    },

    goToAssessment(candidateId: string, assessmentId: string): void {
      router.push({
        path: '/assessor-candidate',
        query: { candidateID: candidateId, assessmentID: assessmentId },
      });
    },

    goToAssessmentRequest(projectId: string): void {
      router.push({
        path: '/assessment-request',
        query: { id: projectId, isInClientProjects: 'false' },
      });
    },

    isProposedDate(slot: { assessment_dates: unknown[] }): boolean {
      return slot.assessment_dates.some((date: { status: string | string[] }) =>
        date.status.includes('proposed'),
      );
    },
  },
};
